/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

/* Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved. */

import React from 'react';
import { Text, Title, UnstyledButton } from '@/shared/ui';

export interface ClientFilters {
  type?: '' | 'individual' | 'company';
  role?: '' | 'demand' | 'supply' | 'both';
  broker?: string;
  imported?: boolean;
  /** Monthly-income window, in BRL, as typed. */
  incomeMin?: string;
  incomeMax?: string;
  /** Where the client LIVES. */
  city?: string;
  neighborhood?: string;
  state?: string;
  /** What the client is LOOKING FOR, read from the demand profile. */
  prefCity?: string;
  prefNeighborhood?: string;
  prefPriceMin?: string;
  prefPriceMax?: string;
  prefBusinessType?: string;
  prefPropertyKind?: string;
  prefBedroomsMin?: string;
  prefPetFriendly?: boolean;
}

export interface ClientFilterPanelProps {
  open: boolean;
  onClose: () => void;
  onApply: (filters: ClientFilters) => void;
  onClear: () => void;
  initialFilters?: ClientFilters;
  brokers?: Array<{ id: string; name: string }>;
}

export const SectionHeader: React.FC<{ icon: React.ReactNode; title: string }> = ({ icon, title }) => (
  <Title order={4}
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 'var(--space-2)',
      fontSize: 'var(--text-meta)',
      fontWeight: 'var(--font-bold)' as unknown as number,
      color: 'var(--text-primary)',
      margin: 0,
      marginBottom: 'var(--space-2)',
    }}
  >
    <Text component="span" style={{ color: 'var(--seed-base)', display: 'flex' }}>{icon}</Text>
    {title}
  </Title>
);

export const ChipBtn: React.FC<{ value: string; active: boolean; onClick: () => void }> = ({ value, active, onClick }) => (
  <UnstyledButton
    type="button"
    onClick={onClick}
    style={{
      padding: 'var(--space-2) var(--space-3)',
      borderRadius: 'var(--radius-md)',
      fontSize: 'var(--text-meta)',
      fontWeight: active ? ('var(--font-semibold)' as unknown as number) : ('var(--font-medium)' as unknown as number),
      fontFamily: 'var(--font-family)',
      cursor: 'pointer',
      transition: 'var(--transition-standard)',
      background: active ? 'color-mix(in srgb, var(--seed-base) 8%, var(--surface-primary))' : 'transparent',
      color: active ? 'var(--seed-base)' : 'var(--text-secondary)',
      border: active ? '1.5px solid color-mix(in srgb, var(--seed-base) 40%, transparent)' : '1px solid var(--border-subtle)',
    }}
  >
    {value}
  </UnstyledButton>
);
